<template>
  <div class="icon-text-cell">
    <i :class="iconClasses" />
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "IconTextCell",
  props: {
    iconClasses: String,
    text: String
  }
};
</script>

<style lang="scss" scoped>
.icon-text-cell {
  @apply flex items-center;

  span {
    @apply ml-1;
  }
}
</style>
